<div class="container-fluid">
	<div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
		<div>
			<h1 class="mb-0">Search</h1>
		</div>
	</div>

	<div class="row">
		<div class="col-12">
			<div class="card shadow-sm rounded-4 border-0">
				<div class="card-body p-2 p-md-3">
					<form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
						<label class="form-label fw-semibold">Search by:</label>

						<!-- Criterion selector, value input, and Search button on one line, each its own box -->
						<div class="d-flex flex-nowrap gap-2 mb-1">
							<select class="form-select" style="flex: 0 0 180px; width: 180px" formControlName="searchType">
								<option *ngFor="let opt of searchOptions" [value]="opt.value">{{ opt.label }}</option>
							</select>

							<input [type]="selectedOption?.inputType || 'text'" class="form-control" style="width: 300px" [placeholder]="selectedOption?.placeholder" formControlName="searchValue" />

							<button type="submit" class="btn px-4 text-nowrap" style="flex: 0 0 auto" [disabled]="isSearching">
								<span *ngIf="!isSearching"><i class="fas fa-search me-2"></i>Search</span>
								<span *ngIf="isSearching">
									<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
									Searching...
								</span>
							</button>
						</div>

						<small class="text-muted d-block mb-4" *ngIf="selectedOption?.helper">
							{{ selectedOption.helper }}
						</small>
					</form>
				</div>

				<ng-container *ngIf="result.length > 0">
					<hr class="m-0" />
					<div class="card-body p-2">
						<div class="table-responsive">
							<table class="table table-hover align-middle mb-0">
								<thead>
									<tr>
										<th scope="col" class="text-uppercase text-muted small fw-semibold py-3">ID</th>
										<th scope="col" class="text-uppercase text-muted small fw-semibold py-3">Prospect</th>
										<th scope="col" class="text-uppercase text-muted small fw-semibold py-3 text-center">Email</th>
										<th scope="col" class="text-uppercase text-muted small fw-semibold py-3 text-center">Phone</th>
										<th scope="col" class="text-uppercase text-muted small fw-semibold py-3 text-center">Company</th>
										<th scope="col" class="py-3"></th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let prospect of result">
										<td class="py-3">
											<span class="text-primary fw-semibold">{{ prospect.id }}</span>
										</td>
										<td class="py-3 fw-semibold">{{ prospect.first_name }} {{ prospect.last_name }}</td>
										<td class="py-3 text-center">{{ prospect.primary_email | nullToDash }}</td>
										<td class="py-3 text-center">
											<a [href]="'tel:' + prospect.primary_phone" class="text-primary text-decoration-none">{{ prospect.primary_phone | phone }}</a>
										</td>
										<td class="py-3 text-muted text-center">{{ prospect.company_name | nullToDash }}</td>
										<td class="py-3 text-end">
											<button (click)="openCampaignModal(campaignModal, prospect.primary_phone)" class="btn btn-sm btn-primary px-3">Open</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</ng-container>

				<!-- Campaigns Modal -->
				<ng-template #campaignModal let-modal>
					<div class="modal-header">
						<h5 class="modal-title">Select Campaign</h5>
						<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
					</div>
					<div class="modal-body py-4">
						<label class="form-label fw-semibold">Campaign</label>

						<div class="d-flex align-items-center gap-2 mb-2" *ngIf="isLoadingCampaigns">
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							<small class="text-muted">Refreshing campaigns...</small>
						</div>

						<input type="text" class="form-control" [placeholder]="isLoadingCampaigns ? 'Loading campaigns...' : 'Click to see all campaigns, or type to search...'" [(ngModel)]="campaignSearchTerm" name="campaignSearch" #campaignTypeahead="ngbTypeahead" [ngbTypeahead]="searchCampaigns" [resultFormatter]="campaignFormatter" [inputFormatter]="campaignFormatter" [disabled]="isLoadingCampaigns" (selectItem)="onCampaignSelected($event)" (focus)="onCampaignInputFocus($event.target.value)" (click)="onCampaignInputClick($event.target.value)" />
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" (click)="modal.close()">Close</button>
						<button type="button" class="btn btn-primary" [disabled]="isLoadingCampaigns || isValidatingCampaign" (click)="openProspect()">
							<span *ngIf="!isValidatingCampaign">Open</span>
							<span *ngIf="isValidatingCampaign">
								<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
								Loading...
							</span>
						</button>
					</div>
				</ng-template>
			</div>
		</div>
	</div>
</div>
